export * from "./second";
export * from "./prime";
